import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
  target?: string;
  rel?: string;
}
const Button = ({
  children,
  href,
  variant = 'primary',
  type = 'button',
  className = '',
  onClick,
  target,
  rel
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center font-display font-semibold text-sm tracking-widest rounded transition-all duration-300';
  const variantStyles = {
    primary: 'bg-primary text-secondary hover:bg-gold-glow hover:shadow-gold-md px-6 py-3',
    secondary: 'bg-transparent border-2 border-primary text-primary hover:bg-primary hover:text-secondary px-6 py-3'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${className}`;
  if (href) {
    if (href.startsWith('http')) {
      return <a href={href} className={styles} target={target} rel={rel} data-id="element-98">
          {children}
        </a>;
    }
    return <Link to={href} className={styles} data-id="element-99">
        {children}
      </Link>;
  }
  return <button type={type} className={styles} onClick={onClick} data-id="element-100">
      {children}
    </button>;
};
export default Button;